import { render } from "./humanityCourse.vue?vue&type=template&id=c658c0d2&scoped=true"
import script from "./humanityCourse.vue?vue&type=script&lang=js"
export * from "./humanityCourse.vue?vue&type=script&lang=js"

import "./humanityCourse.vue?vue&type=style&index=0&id=c658c0d2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c658c0d2"]])

export default __exports__